<!--Description:编码属性配置-->
<!--Created by qgn on 2019/1/15-->
<template lang='pug'>
.page-wrap
  .container-wrap(v-show='treeData && treeData.length')
    el-row(:gutter='15')
      el-col(:span='5')
        div
          .title
            el-row
              el-col(:span='24') 
                span 属性列表
          .tree-wrapper
            el-tree(check-strictly, 
              :data='treeData', 
              ref='attrTree',
              @node-click='treeNodeClickHandle',
              node-key='id',
              :expand-on-click-node='true',
              :props='treeDefaultProps',
              :default-expanded-keys="defaultExpandedArr"
              @node-expand="treeNodeExpandHandle"
              @node-collapse="treeNodeCollapseHandle"
              highlight-current,
              v-show='treeData.length')
              tree-node(slot-scope='{ node, data }',
                :nodeName='data.attrName', elIcon='el-icon-plus',
                :isShowBtn='data.attrKey + "" === "serial"',
                :iconClass = 'iconMap[data.attrKey]',
                @showContextMenu='(e) => addAttrType(e, data, node)',)
      el-col(:span='19')
        div
          .title
            el-row
              el-col(:span='24', v-show='actionType === "add"')
                svg-icon.iconColor(icon-class='jiahao')
                span 新增流水号
              el-col.text-overflow(:span='24', v-show='actionType === "edit"')
                svg-icon.iconColor(icon-class='current_place')
                span(:title="(selectedNode && selectedNode.attrName) || ''") 当前选中 : {{ (selectedNode && selectedNode.attrName) || '' }}
          div
            el-form(label-position='right', label-width='100px'
              v-show='actionType=== "edit"&& isShowHandle(selectedNode)')
              el-form-item(label='属性编码：', prop='attrKey')
                span {{selectedNode.attrKey}}
              el-form-item(label='属性名称：', prop='attrName')
                span {{selectedNode.attrName}}
              el-form-item(label='属性类型：', prop='attrType')
                span {{ getValueMap('attrType',selectedNode.attrType)}}
              el-form-item(label='使用类型：', prop='useType')
                span(v-if='!selectedNode.useType')
                span(v-for='(val,index) in selectedNode.useType?selectedNode.useType.split(","):[]',:key='index')
                  span {{getValueMap('useType',val)}}
                  span(v-show='(index+1) !== selectedNode.useType.split(",").length')  ，
              el-form-item(label='描述：', prop='description')
                span {{selectedNode.description}}
            el-form(:model='selectedNode', label-position='right', label-width='100px', ref='addForm',
              v-if='!isShowHandle(selectedNode)' :rules="formRules")
              el-form-item(label='属性编码', prop='attrKey')
                el-input.max-width-300(v-model='selectedNode.attrKey', placeholder='请输入属性编码')
              el-form-item(label='属性名称', prop='attrName')
                el-input.max-width-300(v-model='selectedNode.attrName', placeholder='请输入属性名')
              el-form-item(label='使用类型', prop='useTypeArr')
                el-select(style='width:100%',v-model='selectedNode.useTypeArr', placeholder='请选择使用类型', multiple,@change='typeChange')
                  el-option(v-for='(option,index) in ruleTypes', :key='index',
                    :label='option.label', :value='option.value', :disabled='option.disabled')
              el-form-item(label='描述', prop='description')
                el-input(v-model='selectedNode.description', placeholder='请输入描述', type='textarea' :autosize="{ minRows: 5, maxRows: 10}" resize="none",maxlength='200')
              el-form-item(label='自增属性', prop='incrementList')
                div
                  svg-icon.iconColor(icon-class='jiahao')
                  el-button(type='text', @click='openDialog({type:"add",dataKey:"incrementList"})') 添加
                .dataTable
                  el-table(:data='selectedNode.incrementList', size='mini', border, stripe,
                  element-loading-text='加载中...', element-loading-spinner="el-icon-loading",
                  highlight-current-row)
                    el-table-column(type='index', label='序号', width='60')
                    el-table-column(v-for='(column,index) in getTableColumn()', :key='index', :label='column.label',
                    :prop='column.prop', :formatter='column.formatter', show-overflow-tooltip)
                    el-table-column(label='操作')
                      template(slot-scope='scope')
                        el-button(type='text', @click='openDialog({type:"edit",row:scope,dataKey:"incrementList"})') 编辑
                        el-button(type='text', @click='delTableRow({row:scope,dataKey:"incrementList"})') 删除
              el-form-item(label='清零属性',prop='resetList')
                div
                  svg-icon.iconColor(icon-class='jiahao')
                  el-button(type='text', @click='openDialog({type:"add",dataKey:"resetList"})') 添加
                .dataTable
                  el-table(:data='selectedNode.resetList', size='mini', border, stripe,
                  element-loading-text='加载中...', element-loading-spinner="el-icon-loading",
                  highlight-current-row)
                    el-table-column(type='index', label='序号', width='60')
                    el-table-column(v-for='(column,index) in getTableColumn()', :key='index', :label='column.label',
                    :prop='column.prop', :formatter='column.formatter', show-overflow-tooltip)
                    el-table-column(label='操作')
                      template(slot-scope='scope')
                        el-button(type='text', @click='openDialog({type:"edit",row:scope,dataKey:"resetList"})') 编辑
                        el-button(type='text', @click='delTableRow({row:scope,dataKey:"resetList"})') 删除
              div.pageSaveWrap
                el-button(type='primary', @click='save' size="mini" :loadinng="saveLoading") 保存
  el-dialog(:visible.sync='dialogVisible', :title='propertyActionType === "add"?"添加":"编辑"', custom-class='selfDialog',
    width='600px', @close='closeDialog')
    .dialog-wrap
      el-form(:model='dialogData', label-position='right', label-width='100px', ref='dialogFormRef', size='small')
        el-form-item(label='属性选择', prop='idList', :rules="{required: true, message: '属性不能为空', trigger: 'change'}")
          el-cascader.width-300(@change='valueChange', @blur='valueChange', :options='treeDataByType.filter(item => item.attrKey !== "serial")', v-model='dialogData.idList', :props='cascaderProps', placeholder='请选择属性')
        el-form-item(label='时间格式', prop='format', v-if='getCurrentOption()', :rules="{required: true, message: '请选择时间格式', trigger: 'change'}")
          el-select.width-300(v-model='dialogData.format', placeholder='请选择时间格式')
            el-option(v-for='(option,index) in formatOptions', :key='index', :label='option.label', :value='option.value')
    span(slot="footer" class="dialog-footer")
      el-button(@click='submitDialog', size='small', type='primary') 确定
      el-button(@click='dialogVisible = false', size='small') 取消
  div(v-show='!treeData || !treeData.length', style='background-color: #fff;height:100%')
    emptyBody(empty_text='暂无数据')  
</template>

<script>
import emptyBody from '../../components/empty_body.vue'
import treeNode from '@/components/treeNode/treeNode.vue'
import {
  getCodeAttrs,
  getRulesType,
  editCodeAttrs,
  getAttrsByType
} from '@/service/api/barcodeApi.js'
import { selectOptions,dataMap, keyMap } from '@/utils/options.js'
import { validateIllegality } from '@/utils/validate.js'
import _ from 'lodash'
export default {
  name: '',
  components: {
    emptyBody,
    treeNode
  },
  data() {
    return {
      saveLoading: false,
      defaultExpandedArr: [],
      dialogVisible: false,
      ruleTypes: [],
      listKey: '',
      selectedNode: {
        attrKey: '',
        attrName: '',
        attrType: '',
        children: [],
        createType: '',
        createdBy: '',
        createdTime: '',
        description: '',
        extendAttr: '',
        id: '',
        factoryId: '',
        modifiedBy: '',
        isDelete: '',
        parentId: '',
        modifiedTime: '',
        useType: '',
        valueType: -1,
        useTypeArr: [],
        incrementList: [],
        resetList: []
      },
      dialogData: {
        format: '',
        idList: []
      },
      treeDataByType:[],
      treeData: [],
      selectedRow: null,
      tableLoading: false,
      propertyActionType: '',
      actionType: '',
      editData: null,
      cascaderData: null,
      iconMap: {
        'base': 'operate',
        'outputDetail': 'chanchu',
        'workOrder': 'gongdan',
        'barcodeInfo': 'biaoshi',
        'material': 'wuliao',
        'other': 'other',
        'serial': 'liushuihao'
      },
      formRules: {
        attrKey: [
          { required: true, message: '属性编码不能为空' },
          { min: 1, max: 64, message: '长度在64个字符以内' },
          { validator: this.checkAttrKey, trigger: 'blur' }
        ],
        attrName: [
          { required: true, message: '属性名称不能为空'},
          { min: 1, max: 64, message: '长度在64个字符以内' },
          {validator: validateIllegality, trigger: 'blur' }
        ],
        description: [
          { min: 0, max: 200, message: '长度在200个字符以内', trigger: 'blur' }
        ],
        useTypeArr: [{ required: true, message: '请选择使用类型', trigger: 'change'}],
        incrementList: [{ required: true, message: '请添加自增属性，若需要流水号一直递增，可设置为"全局标识"', trigger: 'change' }],
        resetList: [{ required: true, message: '请添加清零属性，若需要流水号一直递增，可设置为"固定字符"', trigger: 'change' }]
      },
      existedAttrKey: []
    }
  },
  computed: {
    // 树节点默认属性名
    treeDefaultProps() {
      return {
        children: 'children',
        label: 'attrName'
      }
    },
    formatOptions() {
      return selectOptions.format
    },
    factoryId() {
      return this.$store.getters.factoryId || ''
    },
    cascaderProps() {
      return {
        children: 'children',
        value: 'id',
        label: 'attrName'
      }
    }
  },
  watch: {},
  created() {
    this.getRulesType()
  },
  mounted() {
    this.getAttrs()
  },
  methods: {
    /**
     * 类型变化
     * @param {Array} typeValue
     */
    typeChange(typeValue){
      if(Array.isArray(typeValue) &&  typeValue.length){
        this.getDataByType(typeValue)
      }
    },
    /**
     * 根据参数获取属性
     * @param {Array} value
     */
    getDataByType(value){
      getAttrsByType(value).then(res => {
        if(res.data && res.data.length){
          this.treeDataByType = res.data
          return 
        }
         this.treeDataByType = []
      }).catch(() => {
        this.treeDataByType = []
      })
    },
    // 属性编码校验方法
    checkAttrKey(rule, value, callback) {
      let reg = /^[_a-zA-Z0-9-#*,.$()]+$/

      if (!reg.test(value)) {
        callback(`请输入英文、数字、-_#*,.$()`)
      } else {
        this.existedAttrKey = []
        this.treeData.forEach(item => this.filterAttrKey(item))

        if (this.actionType === "edit") {
          this.existedAttrKey = this.existedAttrKey.filter(item => item !== this.selectedNode.attrKey)
        }

        let index = this.existedAttrKey.indexOf(value)
        if (index !== -1) {
          callback('属性编码已存在')
        } else {
          callback()
        }
      }
    },
    filterAttrKey(item) {
      this.existedAttrKey.push(item.attrKey)

      if (item.children && item.children.length) {
        item.children.forEach(childItem => this.filterAttrKey(childItem))
      }
    },
    /**
     * 获取值映射
     * @param {String} dataKey
     * @param {String} dataValue
     */
    getValueMap(dataKey, dataValue) {
      return (dataMap[dataKey] && dataMap[dataKey][dataValue]) || dataValue
    },
    /**
     * 选择器失去焦点
     */
    valueChange() {
      const ids = this.dialogData.idList
      if (ids && ids.length) {
        const flatArr = this.flat(this.treeData)
        this.cascaderData = flatArr.find(
          item => item.id + '' === ids[ids.length - 1] + ''
        )
        if (this.cascaderData.attrKey !== 'other.currenttime') {
          this.dialogData.format = ''
        }
        return
      }

      this.cascaderData = null
      this.closeDialog()
    },
    /**
     * 判断
     */
    getCurrentOption() {
      const ids = this.dialogData.idList
      if (ids && ids.length) {
        const flatArr = this.flat(this.treeData)
        this.cascaderData = flatArr.find(
          item => item.id + '' === ids[ids.length - 1] + ''
        )
        if (this.cascaderData.attrKey !== 'other.currenttime') {
          this.dialogData.format = ''
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    /**
     * 关闭弹窗清空数据
     */
    closeDialog() {
      this.$refs.dialogFormRef && this.$refs.dialogFormRef.resetFields()
    },
    /**
     * 打开弹窗
     * @param {Object} params
     */
    openDialog(params) {
      if (this.selectedNode.useTypeArr && !this.selectedNode.useTypeArr.length) {
        this.$message.warning('请先选择使用类型')
        return
      }

      if (params.type ==="add") {
        if (params.dataKey === "incrementList" && this.selectedNode.incrementList.length >= 5) {
          this.$message.warning('自增属性最多添加5个')
          return
        } else if (params.dataKey === "resetList" && this.selectedNode.resetList.length >= 5) {
          this.$message.warning('清零属性最多添加5个')
          return
        }
      }
      const fns = {
        add(row, dataKey) {
          this.closeDialog()
        },
        edit(row, dataKey) {
          this.dialogData = JSON.parse(JSON.stringify(row))
        }
      }
      this.editData = params || null
      fns[params.type] &&
        fns[params.type].call(
          this,
          (params.row && params.row.row) || null,
          params.dataKey
        )
      this.propertyActionType = params.type
      this.dialogVisible = true
      this.listKey = params.dataKey
    },
    /**
     * 弹窗提交表单
     */
    submitDialog() {
      const fns = {
        add() {
          this.selectedNode[this.listKey].push({
            format: this.dialogData.format,
            attrName: this.cascaderData.attrName,
            idList: this.dialogData.idList
          })
        },
        edit() {
          let copyDialogData = JSON.parse(JSON.stringify(this.dialogData))
          this.$set(this.selectedNode[this.listKey], this.editData.row.$index, {
            format: copyDialogData.format,
            attrName: this.cascaderData.attrName,
            idList: copyDialogData.idList
          })
        }
      }
      this.$refs.dialogFormRef.validate(valid => {
        if (valid) {
          fns[this.editData.type] && fns[this.editData.type].call(this)
          this.dialogVisible = false
          this.closeDialog()
          this.$refs.addForm.validateField(this.listKey)
        }
      })
    },
    /**
     * 删除弹窗提交数据
     * @param {Object} params
     */
    delTableRow(params) {
      this.selectedNode[params.dataKey].splice(params.row.$index, 1)
    },
    /**
     * 获取表格显示列
     */
    getTableColumn() {
      return [
        {
          label: '属性名',
          prop: 'attrName'
        },
        {
          label: '格式/模板',
          prop: 'format',
          formatter: function(row, column) {
            return row.format || 'N/A'
          }
        }
      ]
    },
    /**
     * 条件判断
     * @param {Object} data
     */
    isShowHandle(data) {
      if (data.parentId) {
        if (this.getParent(data).attrKey + '' !== 'serial') {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    /**
     * 获取父级
     * @param {Object} data
     */
    getParent(data) {
      const flatArr = this.flat(this.treeData)
      const oData = flatArr.find(item => item.id + '' === data.parentId + '')
      return oData
    },
    /**
     * 扁平化
     * @param {Array} sourceData
     */
    flat(sourceData) {
      let flatArr = []
      function setValue(option) {
        option.map(item => {
          flatArr.push(item)
        })
      }

      function findChildren(node) {
        if (node.children && node.children.length) {
          setValue(node.children)
          node.children.map(item => {
            findChildren(item)
          })
        }
      }
      sourceData.map(item => {
        findChildren(item)
        flatArr.push(item)
      })

      return flatArr
    },
    // 树节点展开事件
    treeNodeExpandHandle(oData, node, tree) {
      this.defaultExpandedArr.push(oData.id)
    },
    // 树节点关闭事件
    treeNodeCollapseHandle(oData, node, tree) {
      this.defaultExpandedArr = _.cloneDeep(this.defaultExpandedArr.filter(item => item !== oData.id))
    },
    /**
     * 树节点点击事件
     * @param {Object} oData
     * @param {Array} node
     * @param {Object} tree
     */
    treeNodeClickHandle(oData, node, tree) {
      this.actionType = 'edit'
      const sourceData = this.flat(this.treeData)
      
      this.selectedNode = {
        ...JSON.parse(JSON.stringify(oData)),
        useTypeArr: oData.useType ? oData.useType.split(',') : '',
        incrementList: oData.extendAttr
          ? JSON.parse(oData.extendAttr).incrementList.map(item => {
            let targetData = sourceData.find(o => o.id+'' === item.id+'')
            return {
              attrName: targetData.attrName,
              id:item.id,
              format:item.format,
              idList:item.id?[targetData.parentId,item.id]:[]
            }
          })
          : [],
        resetList: oData.extendAttr
          ? JSON.parse(oData.extendAttr).resetList.map(item => {
            let targetData = sourceData.find(o => o.id+'' === item.id+'')
            return {
              attrName: targetData.attrName,
              id:item.id,
              format:item.format,
              idList:item.id?[targetData.parentId,item.id]:[]
            }
          })
          : []
      }
      this.typeChange(this.selectedNode.useTypeArr)
      this.$nextTick(()=>this.$refs.addForm && this.$refs.addForm.clearValidate())
    },
    /**
     * 新增类型
     */
    addAttrType() {
      const oData = this.treeData.find(item => item.attrKey === 'serial')
      this.treeNodeClickHandle(oData)
      this.$refs.attrTree && this.$refs.attrTree.setCurrentKey(oData.id)
      this.$nextTick(() => {
        this.actionType = 'add'
        const keys = ['attrKey', 'attrName', 'useType', 'description']
        keys.map(key => {
          this.selectedNode[key] = ''
        })
        this.selectedNode.useTypeArr = []
        this.selectedNode.parentId = this.selectedNode.id
        this.selectedNode.id = null
        this.selectedNode.children = []
        this.$refs.attrTree && this.$refs.attrTree.setCurrentKey(oData.id)
      })
    },
    /**
     * 保存配置
     */
    save() {
      this.$refs.addForm.validate().then(() => {
        this.saveLoading = true
        const fns = {
          add() {
            copyData.id = null
            copyData.valueType = 5
            copyData.attrType = 5
            editCodeAttrs(copyData).then(res => {
              this.saveLoading = false
              if (res.data) {
                this.getAttrs()
              }
            }).catch(() => {this.saveLoading = false})
          },
          edit() {
            editCodeAttrs(copyData).then(res => {
              this.saveLoading = false
              if (res.data) {
                this.$message({
                  type: 'success',
                  message: '保存成功'
                })
                const uniqueIndex = this.treeData.findIndex(
                  item => item.attrKey + '' === 'serial'
                )
                let sourceData = this.treeData.find(
                  item => item.attrKey + '' === 'serial'
                )
                const index = sourceData.children.findIndex(
                  item => item.id + '' === copyData.id + ''
                )
                let copyTreeData = JSON.parse(JSON.stringify(this.treeData))
                copyTreeData[uniqueIndex].children[index] = copyData
                this.treeData = copyTreeData
                this.$nextTick(() => {
                  this.$refs.attrTree && this.$refs.attrTree.setCurrentKey(copyData.id)
                })
                this.$refs.addForm && this.$refs.addForm.clearValidate()
              }
            }).catch(() => {this.saveLoading = false})
          }
        }
        let copyData = JSON.parse(JSON.stringify(this.selectedNode))
        copyData.incrementList.forEach(item => {
          item.id = item.idList[item.idList.length - 1]
          delete item.idList
          delete item.attrName
        })
        copyData.resetList.forEach(item => {
          item.id = item.idList[item.idList.length - 1]
          delete item.idList
          delete item.attrName
        })
        copyData.extendAttr = JSON.stringify({
          incrementList: copyData.incrementList,
          resetList: copyData.resetList
        })
        copyData.useType = copyData.useTypeArr.join(',')
        let keys = ['incrementList','resetList','useTypeArr','validAttrType','validCreateType','validExtendAttr','validValueType']
        keys.map(key => {
          delete copyData[key]
        })
        copyData.factoryId = this.factoryId
        fns[this.actionType] && fns[this.actionType].call(this)
      })

    },
    /**
     * 获取属性
     */
    getAttrs() {
      getCodeAttrs(this.factoryId).then(res => {
        if (res.data && res.data.length) {
          this.treeData = res.data.concat()

          if (this.actionType !== 'add') {
            this.treeNodeClickHandle(res.data[0])
            this.$nextTick(() => {
              this.$refs.attrTree &&
              this.$refs.attrTree.setCurrentKey(res.data[0].id)
            })
          } else {
            this.addAttrType()
          }

          return
        }
        this.treeData = []
      })
    },
    /**
     * 获取规则类型
     */
    getRulesType() {
      getRulesType().then(res => {
        if(res.data && res.data.length){
          const options = Object.keys(res.data[0]).map(key => {
            return {
              label: res.data[0][key],
              value: key
            }
          })
          this.ruleTypes = options
          return 
        }
        this.ruleTypes = []
      })
    }
  }
}
</script>

<style scoped lang="scss">

.pageSaveWrap {
  text-align: center;
  margin-top: 15px;
}
.container-wrap{
  height:100%;
  &>.el-row,&>.el-row>.el-col{
    height:100%;
  }
  &>.el-row>.el-col>div{
    height:100%;
    background-color:#fff;
  }
  .addType{
      text-align:right;
      padding-bottom:15px;
    }
  .title+div{
    .el-form{
      padding:15px 10%;
    }
  }
}
</style>
